module.exports = __webpack_public_path__ + "static-kuaikan-h5-fe/img/user.42e8b44.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kkmh/pays/src/components/kkbhalfscreen/img/user.png
// module id = hWpv
// module chunks = 1